import React from 'react'

function WorkAndEducation() {
  return (
    <div className=''>
      <h1 className='text-lg font-semibold mb-2'>Work</h1>
      <p className='text-md mb-3'>Works at <span className='font-semibold'>Beginner Learning Academy</span></p>
      <h1 className='text-lg font-semibold mb-2'>University</h1>
      <p className='text-md mb-3'>Studies MBA in Management Studies at <span className='font-semibold'>Jagannath University</span></p>
      <p className='text-md mb-3'>Studied B.Sc. in CSE at <span className='font-semibold'>University of Information Technology and Sciences (UITS)</span></p>
      <h1 className='text-lg font-semibold mb-2'>College</h1>
      <p className='text-md mb-3'>Went to <span className='font-semibold'>Siddheswari College</span></p>
      <h1 className='text-lg font-semibold mb-2'>School</h1>
      <p className='text-md'>Went to <span className='font-semibold'>Motijheel Model School and College</span></p>
    </div>
  )
}

export default WorkAndEducation
